import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./StartTaskPage.css";
import search from "../../../assets/search.png";
import FakeNavigation from "../../../components/FakeNav/FakeNav";

const StartTaskPage: React.FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false); // Состояние для отображения модального окна

  const handleStartTest = () => {
    setShowModal(true); // Открыть модальное окно
  };

  const handleConfirmStart = () => {
    setShowModal(false); // Закрыть модальное окно
    const startTime = new Date().toISOString(); // Сохраняем время завершения
    localStorage.setItem("startTime", startTime);
    navigate("/task"); // Перейти на страницу /task
  };

  const handleCancelStart = () => {
    setShowModal(false); // Закрыть модальное окно без действий
  };

  return (
    <div role="main" className="wrapper">
      <div className="title"></div>
      <div className="title23">
        <div>Решение ситуационных задач - 3-й этап (Мультикейсы)</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="container">
        <div className="content">
          <div
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
            className="gohome"
          >
            Выход
          </div>
          <div
            style={{
              color: "",
              fontSize: "1.7vw",
            }}
          >
            Ситуационная задача
          </div>
          <div className="box2 quizinfo">
            <p>Ограничение по времени: 30 мин.</p>
            <p>Метод оценивания: Последняя попытка</p>
          </div>

          <div className="btn-cont">
            <button className="button" onClick={handleStartTest}>
              Начать тестирование
            </button>
          </div>
        </div>
        <FakeNavigation />
      </div>

      {/* Модальное окно */}
      {showModal && (
        <div className="modal-backdrop">
          <div className="modal">
            <div className="modal-title">Начать попытку</div>
            <div style={{ paddingLeft: 10, fontSize: 24 }}>
              Тест с ограничением по времени
            </div>
            <div className="modal-text">
              <p>
                Время на тест ограничено и равно 30 мин. Будет идти обратный
                отсчет времени с момента начала вашей попытки, и вы должны
                завершить попытку теста до окончания времени.
                <br /> Вы уверены, что хотите начать прямо сейчас?
              </p>
            </div>
            <div className="modal-buttons">
              <button onClick={handleConfirmStart} className="confirm-btn">
                Начать попытку
              </button>
              <button onClick={handleCancelStart} className="cancel-btn">
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StartTaskPage;
